import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShoppableFeedComponent } from './feed/shoppable-feed.component';

const routes: Routes = [{ path: '', component: ShoppableFeedComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
